import tw, { styled } from 'twin.macro';

const Container = styled.section(({ width = 'default', padding }) => [
  tw`mx-auto  px-10 py-8`,
  width === 'default' && tw`max-w-screen-2xl `,
  width === 'full' && tw`container `,
  padding === 'null' && tw`p-0`,
]);

export default Container;
